// PLATFORM-OPERATOR: the platform operator's display name, one setting for every UI text that
// names who runs the platform ("Submit to …", "… sets it up"). It comes from `/v1/me`
// (`operator_name`, `cp.platform_setting operator_name`); never hard-code a company's name.
import { useContext } from "react";
import type { MeResponse } from "../api/types";
import { SessionContext } from "./use-feature";

/** Shown when the install has no operator name set. */
export const DEFAULT_OPERATOR_NAME = "Operator";

/** The operator's name from a `/v1/me` payload (the default when unset or blank). */
export function operatorNameOf(me: Pick<MeResponse, "operator_name"> | null | undefined): string {
  return me?.operator_name?.trim() || DEFAULT_OPERATOR_NAME;
}

/** The operator's name for the signed-in session; the default outside the authenticated shell. */
export function useOperatorName(): string {
  return operatorNameOf(useContext(SessionContext)?.me);
}
